import Vue from "vue";
import VueRouter from "vue-router";
import { hasBillingAccess } from "@/utils/billingAccess";
import Login from "../views/Login.vue";
import Router from "vue-router";
import SuperAdminLogin from "../views/SuperAdminLogin.vue";
import LinkExpiry from "../views/LinkExpiry.vue";
// Lazy: both files statically import chart.js and exceljs, which otherwise
// land in the eager critical-path chunk for every login, whether or not the
// session ever opens a TAT dashboard.
const CTTATDashboard = () =>
  import(/* webpackChunkName: "CTTATDashboard" */ "../views/CTTatDashboard.vue");
const MRTATDashboard = () =>
  import(/* webpackChunkName: "MRTATDashboard" */ "../views/MRTatDashboard.vue");

// import store from '../store/index'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const localHostnames = ["localhost", "127.0.0.1", "0.0.0.0"];
const isLocalDevelopment =
  typeof window !== "undefined" &&
  localHostnames.includes(window.location.hostname);

const routes = [
  {
    path: "/billing",
    name: "Billing",
    component: () =>
      import(
        "../views/PatientBilling/BillingShell.vue"
      ),
    meta: { module: "billing", requiresAuth: true },
  },

  { path: "/billingDashboard", redirect: { path: "/billing", query: { tab: "dashboard" } } },
  { path: "/patientBilling", redirect: { path: "/billing", query: { tab: "dashboard" } } },
  { path: "/billing/collections", redirect: { path: "/billing", query: { tab: "dashboard" } } },
  { path: "/billing/dashboard", redirect: { path: "/billing", query: { tab: "dashboard" } } },
  { path: "/billing/analytics", redirect: { path: "/billing", query: { tab: "analytics" } } },
  { path: "/billing/reports", redirect: { path: "/billing", query: { tab: "reports" } } },
  { path: "/billing/settings", redirect: { path: "/billing", query: { tab: "settings" } } },
  { path: "/billing/accounts", redirect: { path: "/billing", query: { tab: "accounts" } } },
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    /*
     * Public patient-facing booking. Deliberately carries no `requiresAuth`
     * and sits outside every master view: a patient reaches it without a
     * QuickRad session of any kind and signs in against its own patient
     * account, which is separate from the admin/rad/telerad logins.
     */
    path: "/online-booking",
    name: "OnlineBooking",
    component: () =>
      import(
        /* webpackChunkName: "OnlineBooking" */ "../views/OnlineBooking/OnlineBooking.vue"
      ),
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "Register" */ "../views/Register.vue"),
  },

  {
    path: "/mrTatDashboard",
    name: "MRTATDashboard",
    component: MRTATDashboard,
  },
  {
    path: "/ctTatDashboard",
    name: "CTTATDashboard",
    component: CTTATDashboard,
  },

  {
    path: "/superAdminLogin",
    name:"AikenSuperAdminLogin",
    component: SuperAdminLogin,
  },
  {
    path: "/linkExpiry",
    name:"LinkExpiry",
    component: LinkExpiry,
  },

  {
    path: "/superAdminMaster",
    name:"Aiken Admin",

    component: () => import(/* webpackChunkName: "Home" */ "../views/SuperAdminMaster.vue"),
  },
  {
    path: "/home",
    name: "Home",

    component: () => import(/* webpackChunkName: "Home" */ "../views/Home.vue"), // this style
  },
  {
    path: "/forgotPassword",
    name: "ForgotPassword",

    component: () => import(/* webpackChunkName: "fortgotpasswor" */ "../views/forgotPassword.vue"), // this style
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import(/* webpackChunkName: "fortgotpasswor" */ "../views/resetPassword.vue"), // this style
  },
  {
    path: "/viewer",
    // path: '/viewer/:uid',
    name: "Viewer",

    component: () =>
      import(/* webpackChunkName: "Viewer" */ "../views/Viewer.vue"), // this style
  },
  {
    path: "/adminmaster",
    name: "AdminMaster",

    component: () =>
      import(/* webpackChunkName: "AdminMaster" */ "../views/AdminMaster.vue"), // this style
  },
  {
    path: "/operator",
    name: "Operator",

    component: () => import("../views/Operator/Operator.vue"), // this style
  },
  {
    path: "/radmaster",
    name: "RadMaster",

    component: () =>
      import(/* webpackChunkName: "RadMaster" */ "../views/RadMaster.vue"), // this style
  },
  {
    path: "/refmaster",
    name: "refMaster",

    component: () =>
      import(/* webpackChunkName: "RadMaster" */ "../views/referrerMaster.vue"), // this style
  },
  {
    path: "/referrer",
    name: "Referrer",

    component: () =>
      import( "../views/Referrer.vue"), // this style
  },
  {
    path: "/updateProfile",
    name: "UpdateProfile",

    component: () =>
      import( "../views/UpdateProfile.vue"), // this style
  },
  {
    path: "/physician",
    name: "PhysMaster",

    component: () =>
      import(/* webpackChunkName: "PhysMaster" */ "../views/physMaster.vue"), // this style
  },
  {
    path: "/diagmaster",
    name: "DiagMaster",

    component: () =>
      import(/* webpackChunkName: "DiagMaster" */ "../views/DiagMaster.vue"), // this style
  },
  {
    path: "/diagcenter",
    name: "DiagCenter",

    component: () =>
      import(/* webpackChunkName: "DiagCenter" */ "../views/DiagCenter.vue"), // this style
  },
  {
    path: "/radiologist",
    name: "Radiologist",

    component: () =>
      import(/* webpackChunkName: "Radiologist" */ "../views/Radiologist.vue"), // this style
  },
  {
    path: "/adminsetting",
    name: "Setting",

    component: () =>
      import(/* webpackChunkName: "Settings" */ "../views/AdminSetting.vue"), // this style
  },
  {
    path: "/calendar",
    name: "RecordsCalendar",

    component: () =>
      import(/* webpackChunkName: "RecordsCalendar" */ "../views/Calendar.vue"), // this style
  },
  {
    path: "/radsetting",
    name: "RadSetting",

    component: () =>
      import(
        /* webpackChunkName: "Physician Settings" */ "../views/RadSetting.vue"
      ), // this style
  },
  {
    path: "/physetting",
    name: "PhysSetting",

    component: () =>
      import(/* webpackChunkName: "Rad Settings" */ "../views/physSetting.vue"), // this style
  },
  {
    path: "/diagsetting",
    name: "DiagSetting",

    component: () =>
      import(
        /* webpackChunkName: "Diag Settings" */ "../views/DiagSetting.vue"
      ), // this style
  },
  {
    path: "/theme",
    name: "Theme",

    component: () =>
      import(/* webpackChunkName: "General Settings" */ "../views/theme.vue"), // this style
  },
  {
    path: "/addrad",
    name: "AddRad",

    component: () =>
      import(/* webpackChunkName: "Add Radiologist" */ "../views/addRad.vue"), // this style
  },
  {
    path: "/addphys",
    name: "AddPhys",

    component: () =>
      import(/* webpackChunkName: "Add Physician" */ "../views/addPhys.vue"), // this style
  },
  {
    path: "/addpatient",
    name: "AddPatient",

    component: () =>
      import(/* webpackChunkName: "Add Patient" */ "../views/addPatient.vue"), // this style
  },
  {
    path: "/adddiag",
    name: "AddDiag",

    component: () =>
      import(/* webpackChunkName: "Add Diag" */ "../views/addDiag.vue"), // this style
  },
  {
    path: "/adddiagadmin",
    name: "AddDiagAdmin",

    component: () =>
      import(
        /* webpackChunkName: "Add Diag Admin" */ "../views/addDiagAdmin.vue"
      ), // this style
  },
  {
    path: "/addtechnician",
    name: "addTechnician",

    component: () =>
      import(
        /* webpackChunkName: "Add Technician" */ "../views/addTechnician.vue"
      ), // this style
  },
  {
    path: "/editrad",
    name: "DelRad",

    component: () =>
      import(
        /* webpackChunkName: "Delete Radiologist" */ "../views/editRad.vue"
      ), // this style
  },
  {
    path: "/changepassadmin",
    name: "changePassAdmin",

    component: () =>
      import(
        /* webpackChunkName: "change PassAdmin" */ "../views/changePassAdmin.vue"
      ), // this style
  },
  {
    path: "/technician",
    name: "TechnicianList",

    component: () =>
      import(
        /* webpackChunkName: "Technician Table" */ "../views/TechnicianList.vue"
      ), // this style
  },
  {
    path: "/manager",
    name: "ManagerList",

    component: () =>
      import(
        /* webpackChunkName: "ManagerList Table" */ "../views/ManagerList.vue"
      ), // this style
  },
  {
    path: "/rad",
    name: "RadList",

    component: () =>
      import(
        /* webpackChunkName: "Radiologist Table" */ "../views/RadList.vue"
      ), // this style
  },
  {
    path: "/mapping",
    name: "RadDiagMapping",

    component: () =>
      import(
        /* webpackChunkName: "Radiologist-Diagcentre mapping" */ "../views/RadDiagMapping.vue"
      ), // this style
  },
  {
    path: "/error",
    name: "404_Error",

    component: () =>
      import(/* webpackChunkName: "error" */ "../views/404_Error.vue"), // this style
  },
  {
    path: "/userhome",
    name: "User_Home",

    component: () =>
      import(
        /* webpackChunkName: "Patient Login page" */ "../views/Patient/UserHome.vue"
      ), // this style
  },
  {
    path: "/user",
    name: "User_login",

    component: () =>
      import(
        /* webpackChunkName: "Patient Login page" */ "../views/Patient/User_login.vue"
      ), // this style
  },

  {
    path: "/data",
    name: "Summary",
    // Download final summary
    component: () => import("../views/ReportSummary/ExamData.vue"),
  },
  {
    path: "/mis",
    name: "MISDashboard",
    component: () => import("../views/monitor/TeleradMonitor.vue"),
  },
  {
    path: "/client-intelligence",
    name: "ClientIntelligence",
    component: () => import("../views/MetabaseDashboard.vue"),
  },
];

const router = new VueRouter({
  mode: isLocalDevelopment ? "hash" : "history",
  base: process.env.BASE_URL,
  routes,
});

/*
 * Auth gate for the billing tab.
 *
 * Billing is the first route reachable by pasting a URL into a fresh tab, so it
 * is the first one that needs a real guard - every other screen is only ever
 * arrived at from an already-authenticated session. Without this, hitting
 * /billing/dashboard cold renders the full shell and only fails later, at the
 * first API call, which reads as a broken page rather than a locked one.
 *
 * This is a UX gate, NOT a security boundary. The token travels to Ezheal and
 * Ezheal decides what the token may see; a user who edits localStorage gets a
 * rendered shell and 401s inside it.
 */
router.beforeEach((to, from, next) => {
  if (!to.matched.some((r) => r.meta && r.meta.requiresAuth)) return next();

  const token = localStorage.getItem("token");
  if (!token) {
    return next({ name: "Login", query: { redirect: to.fullPath } });
  }

  const isBilling = to.matched.some(
    (r) => r.meta && r.meta.module === "billing"
  );
  if (isBilling && !hasBillingAccess()) {
    return next({ name: "404_Error" });
  }

  return next();
});

export default router;
